import React, { useState } from 'react'
import jsPDF from 'jspdf'
import imgData from '../../../../Assest/kk.png'
const UserSetMulFunc = ({ row, mat, ques, file, ans, last, Reminder ,divsetspe}) => {
  // const [count, setcount] = useState(0)
  let fl = ""
  const anskey = []
  let temp = 0;

  const generatePDF = () => {
    const today = new Date();
    const dateString = today.toLocaleDateString('en-GB').split('/').reverse().join('-');
    fl = file+" - " + divsetspe + dateString
    // console.log(file)
    for (let i = 0; i < ans.length; i++) {
      if (Reminder) {
        temp = mat[i][0] % mat[i][1]
      }else{
        temp = mat[i][0] /mat[i][1]
      }
      anskey.push(temp)
      temp=0
    }
    var doc = new jsPDF("p", "pt");
    doc.setDrawColor(255, 0, 0);
    let x1 = 20;
    let y1 = 60;
    let x2 = 120;
    let y2 = 0;
    let x3 = 180;
    let y3
    if ((mat[0][0] || mat[0][1]) >= 1000) {
      x2 = 150;
      x3 = 220;
    }
    doc.addImage(imgData, 'PNG', 20, 20, 500, 500);
    doc.addImage(imgData, 'PNG', 30, 350, 500, 500)
    for (let i = 0; i < (ans.length); i++) {
      // doc.text(x1, y1-35, 'q-'+(i+1));
      if (y1 > 800) {
        console.log(x2)
        y1 = 60;
        x1 = 310;
        doc.text(x2 + 290, 30, "UA");
        doc.text(x3 + 290, 30, "CA");
        doc.text(x2 + 290, 30, "UA");
        doc.text(x3 + 290, 30, "CA");
        y2++;
      }
      if (y2 == 2) {
        doc.addPage();
        doc.addImage(imgData, 'PNG', 20, 20, 500, 500);
        doc.addImage(imgData, 'PNG', 30, 350, 500, 500)
        x1 = 20
        y1 = 60
        y2 = 0;
      }
      if (y1 == 60) {
        doc.text(x2, 30, "UA");
        doc.text(x3, 30, "CA");

      }
      mat[i][0] / mat[i][1] != ans[i] ? doc.setTextColor(255, 0, 0) : doc.setTextColor(0, 128, 0);
      let temptext = String(mat[i][0]) + "  ÷  " + String(mat[i][1]) + " = " + " " + String(ans[i]) + " | " +String(anskey[i]);
      doc.text(x1, y1, temptext)
      y1 = y1 + 30;
    }
    doc.save(fl);
  
  };
  return (
    <div className='final-answer'>
      {/* <button className='bt-purple' onClick={generatePDF} type="">Final Result</button> */}
      <button class="Btn" onClick={generatePDF} >
        <svg class="svgIcon" viewBox="0 0 384 512" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path></svg>
        <span class="icon2"></span>
        <span class="tooltip">Download</span>
      </button>
    </div>
  )
}

export default UserSetMulFunc
